import { MAX_RADIUS_IN_METERS } from '../../constants/accredited-establishments'
import { calculateRadiusInMeters } from '../calculate-distance/calculate-distance'

const getRadiusInMeters = (
  bounds?: google.maps.LatLngBoundsLiteral
): number => {
  if (!bounds) return MAX_RADIUS_IN_METERS

  const calculatedRadiusInMeters = calculateRadiusInMeters(
    bounds.north,
    bounds.south,
    bounds.east,
    bounds.west
  )

  const radiusInMeters =
    calculatedRadiusInMeters > MAX_RADIUS_IN_METERS
      ? MAX_RADIUS_IN_METERS
      : calculatedRadiusInMeters

  return radiusInMeters
}

export { getRadiusInMeters }
